<template>
  <div class="order-component" @click.stop="$emit('on-click')">
    <div class="order-box-header" @click.stop="()=>{}">
      <div class="order-no">
        <Checkbox v-if="checkable"
                  v-model="order._checked"/>{{$t('order.order_no')}}{{ order.order_no }}
      </div>
      <div class="order-status"
           :class="'order-status-'+order.status">{{ status[order.status] || err_status }}</div>
    </div>

    <div class="order-box-body">
      <template v-if="detail">
        <Card v-for="(item,i) in order.items" :key="i">
          <div class="goods-image goods-img-detail"
               @click.stop="goGoodsDetail(item.goods_id)">
            <img :src="item.image">
          </div>
          <div class="goods-info">
            <div class="goods-name">{{ item.name }}</div>
            <div>
              <span class="tag">{{$t('goods.price')}}</span>
              <!-- 显示折扣价 -->
              <span class="price">{{YUAN}}{{item.pay_price}}&nbsp;</span>
              <span v-if="item.price !== item.pay_price" class="discount">
                <!--{{$tc('goods.discount', discountVal(item.goods.discount))}}-->
                <s>{{YUAN}}{{item.price|amount}}</s>&nbsp;({{$tc('goods.discount', Math.round(item.pay_price*100/item.price))}})
              </span>

            </div>
            <div>
              <span class="tag">{{$t('order.buy_num')}}</span>
              <span>{{ item.num }}</span>
            </div>
            <!-- 重量 -->
            <div v-if="parseFloat(item.total_weight)>0">
              <span class="tag">{{$t('order.weight')}}</span>
              <span>{{ item.total_weight }}kg</span>
            </div>
          </div>
        </Card>
      </template>
      <div v-else-if="order.items.length===1">
        <div class="goods-image">
          <img :src="order.items[0].image">
        </div>
        <div class="goods-info">
          <div class="goods-name">{{order.items[0].name}}</div>
          <div>
            <span class="tag">{{$t('goods.price')}}</span>
            <!-- 显示折扣价 -->
            <span class="price">{{YUAN}}{{order.items[0].pay_price}}&nbsp;</span>
            <span v-if="order.items[0].price !== order.items[0].pay_price" class="discount">
                <!--{{$tc('goods.discount', discountVal(item.goods.discount))}}-->
                <s>{{YUAN}}{{order.items[0].price|amount}}</s>&nbsp;({{$tc('goods.discount', Math.round(order.items[0].pay_price*100/order.items[0].price))}})
              </span>

          </div>
          <div>
            <span class="tag">{{$t('order.buy_num')}}</span>
            <span>{{ order.items[0].num }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-for="i in (order.items.length > 3 ? 3 : order.items.length)"
             :key="i" class="goods-image" style="margin-right: 3px;">
          <img :src="order.items[i].image">
        </div>
        <span v-if="order.items.length>3">...</span>
      </div>
    </div>

    <div v-if="detail" class="order-amount">
      <div>
        <div>{{$t('order.total_amount')}}</div>
        <div>{{YUAN}}{{order.total|amount}}</div>
      </div>
      <div v-for="p in order.promotions" :key="p.name">
        <div>{{$t('order.promotion_amount')}}</div>
        <div>-{{YUAN}}{{p.promotion_total}}</div>
      </div>
      <div v-if="discountAmount>0">
        <div>{{$t('order.discount_amount')}}</div>
        <div>
          -{{YUAN}}{{discountAmount|amount}}
        </div>
      </div>
      <div v-if="order.pay_coin>0">
        <div>{{$t('page.order_add.use_coin')}}</div>
        <div>
          -{{YUAN}}{{order.pay_coin}}
        </div>
      </div>
    </div>

    <div class="order-box-footer">
      <span v-if="!detail && order.total>order.pay_total" class="discount"><s>{{YUAN}}{{ order.total|amount }}</s></span>
      <span v-if="!detail && order.pay_coin>0">{{$t('page.order_add.use_coin')}}：-{{YUAN}}{{ order.pay_coin }}</span>
      <span class="true-total">{{$t('order.pay_amount')}}：{{YUAN}}{{ order.pay_total|amount }}</span>
      <Icon v-if="!detail" type="ios-arrow-down" size="20"/>
    </div>
  </div>
</template>

<script>
    import Setting from '@/setting';

    export default {
        name: 'Order',
        props: {
            order: {
                type: Object,
                default () {
                    return {
                        order_no: '',
                        complete_time: null,
                        coupon_money: 0,
                        created_at: 0,
                        deleted_at: null,
                        delivery_code: '',
                        delivery_no: '',
                        delivery_time: null,
                        is_settlement: false,
                        items: [],
                        pay_no: null,
                        pay_point: 0,
                        pay_time: null,
                        pay_total: 0,
                        payment_name: null,
                        receipt_time: null,
                        receive_address: '',
                        receive_area: '',
                        receive_name: '',
                        receive_tel: '',
                        refund_id: 0,
                        refund_status: 0,
                        remark: '',
                        status: 0,
                        total: 0
                    }
                }
            },
            detail: Boolean,
            checkable: Boolean
        },
        computed: {
            discountAmount () {
                let discountAmount = 0
                if (this.order.discount) {
                    this.order.items.forEach(item => {
                        if (item.goods_id === this.order.discount.goods_id) {
                            discountAmount = this.order.discount.amount * item.num
                            return true
                        }
                    })
                }
                return discountAmount
            }
        },
        data () {
            return {
                YUAN: Setting.yuan,
                discountVal: Setting.convertDiscount,
                status: Setting.order_status,
                err_status: this.$t('order.err_status')
            }
        },
        methods: {
            goGoodsDetail (goodsId) {
                // console.log(goodsId)
                this.$router.face.goodsDetail(goodsId);
            }
        }
    }
</script>

<style scoped lang="scss">
  .order-component{
    height: auto;
    min-height: 100px;
    border-radius: 5px;
    text-align: left;

    .order-box-header{
      display: flex;
      background-color: #dcdddd;
      line-height: 280%;
      font-size:1rem;
      cursor: default;
      .order-no{
        padding: 0 10px;
        font-weight: bold;
        flex-grow: 1;
      }

      .order-status{
        background-color: #30a851;
        color: #ffffff;
        padding: 0 10px;
        font-weight: bold;
        min-width: 4em;

        &-10{
          background-color: #ff9700;
        }
        &-99{
          background-color: #2f60af;
        }
      }
    }

    .order-box-body{
      background-color: #efefef;
      width: 100%;
      padding: 10px;

      .goods-image {
        width: 23vw;
        height: 0;
        padding-bottom: calc(23vw*1/1 - 2px);//1:1为高宽比
        overflow: hidden;
        text-align: center;
        box-sizing: border-box;
        //position: relative;
        background-image: url("../assets/no-image.png");
        background-size: contain;
        display: inline-block;
        img {
          width: 100%;
          height: auto;
          border-radius: 5px;
        }
      }
      .goods-img-detail{
        cursor: pointer;
      }

      .price{
        color: #ff0606;
      }

      .goods-info{
        display: inline-block;
        padding-left:10px;
        vertical-align: top;
        line-height: 180%;
        .goods-name {
          width: 100%;
          font-size: 1.2rem;
          font-weight: bold;
          text-overflow:ellipsis;
          //white-space: nowrap;
        }
        .tag{
          padding-right: 5px;
        }
      }
    }

    .order-amount{
      border-bottom: 3px solid #ffffff;
      padding-right: 5px;
      &>div{
        line-height: 150%;
        padding: 8px 5px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        &>div:first-child{
          padding-right: 10px;
        }
        &>div:last-child{
          width: 80px;
          text-align: right;
        }
      }
    }

    .order-box-footer{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background-color: #dcdddd;
      padding: 10px 5px;

      :last-child {
        flex-grow: 1;
        text-align: right;
      }

      .true-total{
        font-weight: bold;
      }

      &>span{
        display: inline-block;
        padding: 0 5px 0 0;
      }
    }
  }
</style>
